module.exports = __webpack_public_path__ + "15_vast.jpg?022a51c47f133d936aeca82f7a16ef2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/15_vast.jpg
// module id = 159
// module chunks = 0